<div class="dialog dialog-small dialog-flex-direction-column">
    <h4 class="dialog-inner h4-blue">Infectious & Contagious Disease Benefit</h4>
    <div class="dialog-inner">The Infectious & Contagious Disease Benefit provides income protection for insured
        individuals diagnosed with an infectious and contagious disease, even if they are still physically capable of
        working.

        The insured must have been covered for at least six months and the disease must be classified by the CDC as
        infectious and life threatening (e.g., HIV, hepatitis B, tuberculosis). The insured must experience an earnings
        loss of at least 20% after disclosure and must not have refused immunizations for the disease.</div>
    <div class="dialog-inner semibold">Additional Annual Cost</div>
   <div class="cost">{{cost ? (cost | currency) : 'Calculating...'}}</div>
    <!--
    <br />
    <mat-label class="label-text">Maximum Benefit Duration</mat-label>
    -->
    <br />
    <mat-form-field>
        <mat-label class="label-text">Maximum Duration</mat-label>
        <mat-select [(ngModel)]="IDRDuration" [disabled]="IDRDurationOptions.length <= 1"
            (selectionChange)="updateCost()">
            <mat-option *ngIf="IDRDurationOptions.length <= 1" value="{{IDRDuration}}">{{IDRDuration}}</mat-option>
            @for ( item of IDRDurationOptions; track item ) {
            <mat-option value="{{item}}">{{item}}</mat-option>
            }
        </mat-select>
    </mat-form-field>

    <!--<div class="dialog-inner">Would you like to add this benefit to your policy?</div> -->
    <div *ngIf="!inclusion()" class="dialog-inner-buttons">
        <button class="button-mgis" (click)="no()" class="chat-button chat-button-define" mat-flat-button>Cancel</button>
        <button class="button-mgis" (click)="yes()" class="chat-button chat-button-define" mat-flat-button>Add to Policy</button>

    </div>
    <div *ngIf="inclusion()" class="dialog-inner-buttons">
        <button class="button-mgis" (click)="yes()" class="chat-button chat-button-define" mat-flat-button>Close</button>
    </div>
    <br/>